module.exports = __webpack_public_path__ + "fonts/Roboto-Light.5b55e48d.ttf";